import AlertCircleIcon from "@redotech/redo-icons/alert-circle.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, type ReactNode } from "react";
import * as css from "./experience-banner.module.css";

/** The layout the returns settings and returns experience banners share. */
export const ExperienceBannerShell = memo(function ExperienceBannerShell({
  children,
  action,
  testId,
}: {
  children: ReactNode;
  action?: ReactNode;
  testId?: string;
}) {
  return (
    <Flex
      align="center"
      bgColor="primary"
      borderBottomWidth="1px"
      borderColor="primary"
      borderStyle="solid"
      data-testid={testId}
      gap="lg"
      px="3xl"
      py="lg"
      w="full"
    >
      <RedoFeaturedIcon color="gray" Icon={AlertCircleIcon} />
      <Flex grow={1}>
        <Text fontSize="md" textColor="secondary">
          {children}
        </Text>
      </Flex>
      {action}
    </Flex>
  );
});

/** A link inside a banner sentence, such as "switch back". */
export const ExperienceBannerLink = memo(function ExperienceBannerLink({
  text,
  onClick,
  dataTestId,
  dataTrackId,
}: {
  text: string;
  onClick(): void;
  dataTestId?: string;
  dataTrackId: string;
}) {
  return (
    <RedoButton
      buttonClassName={css.inlineLinkButton}
      className={css.inlineLink}
      dataTestId={dataTestId}
      dataTrackId={dataTrackId}
      hierarchy="link_underline"
      onClick={onClick}
      size="xl"
      text={text}
      textWeight="regular"
    />
  );
});

/** The bold lead-in each banner sentence starts with. */
export const bannerLead = (
  <Text as="span" fontSize="md" fontWeight="semibold" textColor="primary">
    {null}
  </Text>
);
